import { InvoiceType } from "../constants";
import type { TInvoiceAddressesResponse } from "../models/invoiceAddresses";
import type { TInvoiceAddresses } from "../types";

const mapInvoiceAddressesResponse = (response: TInvoiceAddressesResponse): TInvoiceAddresses => ({
  private: {
    type: InvoiceType.PRIVATE,
    contactName: response.private.contactName,
    contactEmail: response.private.contactEmail,
    contactPhone: response.private.contactPhone,
    isDefault: response.private.isDefault,
  },
  company: {
    type: InvoiceType.COMPANY,
    companyName: response.company.companyName,
    email: response.company.email,
    companyCode: response.company.companyCode,
    companyVat: response.company.companyVat,
    country: response.company.country,
    countryCode: response.company.countryCode,
    city: response.company.city,
    street: response.company.street,
    streetNumber: response.company.streetNumber,
    flatNo: response.company.flatNo,
    zip: response.company.zip,
    isDefault: response.company.isDefault,
  },
});
export default mapInvoiceAddressesResponse;
